import { directiveEntriesAdditionalDirectiveSteps } from "../constants/directiveEntriesAdditionalDirectiveSteps.constant";
import { MaintenanceForwardingsDirectiveEntryKlass } from "../types/maintenanceForwardingsDirectiveEntryKlasses.type";
import { MaintenanceForwardingsRequiredDirectiveStepsData } from "../types/maintenanceForwardingsShowDirectiveDetails.type";

export const buildRequiredDirectiveSteps = (
  directiveEntryType: string | undefined,
  requiredDirectiveSteps: MaintenanceForwardingsRequiredDirectiveStepsData | null
) => {
  const additionalDirectiveSteps = directiveEntriesAdditionalDirectiveSteps[directiveEntryType as MaintenanceForwardingsDirectiveEntryKlass];

  if (!additionalDirectiveSteps) {
    return requiredDirectiveSteps;
  }

  return {
    ...additionalDirectiveSteps.beforeRequiredDirectiveSteps.reduce((prev, curr) => ({ ...prev, [curr]: null }), {}),
    ...requiredDirectiveSteps,
    ...additionalDirectiveSteps.afterRequiredDirectiveSteps.reduce((prev, curr) => ({ ...prev, [curr]: null }), {}),
  }
}
